<app-hero [title]="'Wie es funktioniert'" *ngIf="showHero"></app-hero>

<section class="how-work">
  <div class="container">
    <div id="stats-counter" class="mt-5">
      <div class="container section-title" data-aos="fade-up">
        <h2>So funktioniert es</h2>
        <p>Rekrutieren Sie qualifizierte Arbeitskräfte aus dem Ausland in 5 Schritten.</p>
      </div>
    </div>
    <div id="alt-services" class="alt-services" style="margin-top: 0 !important;">
      <div>
        <div *ngFor="let itme of sharedService.whoItWork; let i = index">
          <!-- Regular Content Section -->
          <div *ngIf="!itme.isSlider" 
            class="row justify-content-around gy-4" 
            [ngClass]="{'flex-row-reverse': i % 2 !== 0}"
            style="margin-bottom: 100px;"
          >
            <div class="features-image col-lg-6" data-aos="fade-up" data-aos-delay="100">
              <img [src]="itme.image" alt="Wie es funktioniert Bild">
            </div>
        
            <div class="col-lg-5 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay="200">
              <h3>{{ itme.title }}</h3>
              <div *ngFor="let item of itme.itmes">
                <div class="d-flex position-relative mt-3">
                  <i class="bi bi-check-circle box"></i>
                  <p>{{ item }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Slider Section -->
          <div *ngIf="itme.isSlider" class="slider-container" data-aos="fade-up" style="margin: 60px 0; animation: slideUpOnLoad 0.8s ease-out;">
            <h3 style="text-align: center; margin-bottom: 30px;">{{ itme.title }}</h3>
            <div [id]="'slider-' + i" class="carousel slide" data-bs-ride="carousel" data-bs-interval="5000">
              <div class="carousel-indicators">
                <button *ngFor="let j of [0, 1, 2]; let idx = index" type="button" [attr.data-bs-target]="'#slider-' + i" [attr.data-bs-slide-to]="idx" [ngClass]="{'active': idx === 0}" [attr.aria-current]="idx === 0 ? 'true' : 'false'" [attr.aria-label]="'Slide ' + (idx + 1)" style="width: 12px; height: 12px; border-radius: 50%;"></button>
              </div>

              <div class="carousel-inner" style="border-radius: 15px; overflow: hidden; box-shadow: 0 10px 40px rgba(9, 162, 233, 0.15);">
                <div *ngFor="let item of itme.sliderItems; let idx = index" class="carousel-item" [ngClass]="{'active': idx === 0}">
                  <div class="slider-content" style="position: relative;">
                    <div class="slider-title-top" style="position: absolute; top: 0; left: 0; right: 0; background: linear-gradient(to bottom, rgba(241, 226, 4, 0.6), transparent); padding: 20px; z-index: 10;">
                      <h5 [style.color]="item.color" style="margin: 0; font-weight: 700; font-size: 24px !important;color:aqua !important;">{{ item.label }}</h5>
                    </div>
                    <img [src]="item.image" class="d-block w-100" [alt]="item.label" style="height: 420px; object-fit: cover;">
                    <div class="slider-overlay" [style.background]="'linear-gradient(to top, ' + item.gradientColor + ', transparent)'" style="position: absolute; bottom: 0; left: 0; right: 0; padding: 40px 20px 20px;">
                      <a [href]="item.pdf" download class="btn btn-light" style="font-weight: 600; border-radius: 25px; padding: 12px 35px; transition: all 0.3s ease; display: inline-block;">
                        <i class="bi bi-download me-2"></i>PDF Herunterladen
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Custom Navigation Buttons -->
              <button class="carousel-control-prev" type="button" [attr.data-bs-target]="'#slider-' + i" data-bs-slide="prev" style="width: 50px; height: 50px; border-radius: 50%; background: rgba(255,255,255,0.9); left: 20px; top: 50%; transform: translateY(-50%); border: none; box-shadow: 0 4px 12px rgba(0,0,0,0.2); transition: all 0.3s ease;">
                <i class="bi bi-chevron-left" style="color: #333; font-size: 20px;"></i>
                <span class="visually-hidden">Previous</span>
              </button>
              <button class="carousel-control-next" type="button" [attr.data-bs-target]="'#slider-' + i" data-bs-slide="next" style="width: 50px; height: 50px; border-radius: 50%; background: rgba(255,255,255,0.9); right: 20px; top: 50%; transform: translateY(-50%); border: none; box-shadow: 0 4px 12px rgba(0,0,0,0.2); transition: all 0.3s ease;">
                <i class="bi bi-chevron-right" style="color: #333; font-size: 20px;"></i>
                <span class="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div> 
  </div>
</section>